export default __webpack_public_path__ + "static/media/shoes11.7ad1afef.jpeg";